import React from "react";
import { CXContext } from "./cxContext";
import * as dc from "dc";
import * as d3 from 'd3';
import { rhythm } from "../utils/typography.js";
import { css } from "glamor";

let newChart;
let metric = "Count";
const commasFormatter = (num) => {
  return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)//d3.format(",.0f");
}

const Options = props => {
  const options = ["# of Conversations", "Total Waiting Time", "Average  Waiting Time", "Total Conversation Time", "Average Conversation Time"];
  //this.handleChange = this.handleChange.bind(this);
  const listOptions = options.map((option, i) =>
    <option key= {i} value={option} >{option}</option>
  );
  const style = css({
    marginRight: rhythm(0.2),
    marginTop: rhythm(0.1),
    padding: rhythm(0.05),
    display: "inline",
    cursor:'pointer',
    float:'right',
    fontSize: '12px',
    maxWidth: '160px'
  });

  return (
    <select {...style}
      onChange={ (e) => {
        metric =  e.target.value;
        const val = props.chart[0].valueAccessor(function(p) {
          if( metric == '# of Conversations') return p.value.count;
          else if( metric == 'Total Waiting Time') return p.value.total;
          else if(metric == 'Average  Waiting Time') return p.value.avg;
          else if(metric == 'Total Conversation Time') return p.value.tot_conversation_time;
          else if(metric == 'Average Conversation Time') return p.value.avg_conversation_time;
        });
        const val1 = props.chart[1].valueAccessor(function(p) {
          if( metric == '# of Conversations') return p.value.count;
          else if( metric == 'Total Waiting Time') return p.value.total;
          else if(metric == 'Average  Waiting Time') return p.value.avg;
          else if(metric == 'Total Conversation Time') return p.value.tot_conversation_time;
          else if(metric == 'Average Conversation Time') return p.value.avg_conversation_time;
        });

        if( metric != '# of Conversations' ){
          props.chart[0].yAxis().tickFormat(function(d) { return commasFormatter(d) + ' s'; }).ticks(6);
          props.chart[1].yAxis().tickFormat(function(d) { return commasFormatter(d) + ' s'; }).ticks(3);
        } else {
          props.chart[0].yAxis().tickFormat(function(d) { return commasFormatter(d) ; }).ticks(6);
          props.chart[1].yAxis().tickFormat(function(d) { return commasFormatter(d) ; }).ticks(3);
        }

        props.chart[0].redraw();
        props.chart[1].redraw();
        //dc.calculateColorDomain();
        //dc.redrawAll();
      }}
      >
      {listOptions}
    </select>
  )
}

const ResetButton = props => {
  const style = css({
    fontSize: "10px",
    marginRight: rhythm(0.02),
    marginTop: rhythm(0.2),
    //top: '80px',
    padding: rhythm(0.1),
    display: "inline",
    cursor:'pointer',
    position: 'relative',
    float:'right',
    '&:hover':{
        background: "#ddd",
    }
  });
  return (
    <span
      {...style}
      onClick={() => {
        props.chart.filterAll();
        dc.redrawAll();
      }}
    >
      reset
    </span>
  );
};
export const RangeTemplate = props => {
    /*
    We render the dc chart using an effect. We want to pass the chart as a prop after the dc call,
    but there is nothing by default to trigger a re-render and the prop, by default would be undefined.
    To solve this, we hold a state key and increment it after the effect ran.
    By passing the key to the parent div, we get a rerender once the chart is defined.
    */
  const context = React.useContext(CXContext);
  const [chart,updateChart] = React.useState(null);
  const ndx = context.ndx;
  const calc = metric//context.calc;
  const rangeChart = React.useRef(null);
  const seriesChart = React.useRef(null);
  React.useEffect(() => {
    newChart = props.chartFunction(rangeChart.current, ndx, 'range', null);
    const lChart = props.chartFunction(seriesChart.current, ndx, 'series', newChart);
    lChart.render();
    newChart.render();

    updateChart(newChart);
    updateChart(lChart);
  },1); {/*Run this exactly once */}

  const chartStyles  = css({
    width:'100%',
    height:'auto',
    boxSizing:'border-box',
    padding:rhythm(1),
    paddingRight: rhythm(.01),
    //marginTop: '-60px'
    '& label':{
      textTransform:'capitalize',
    }
  })

  const chartStylesRange  = css({
    width:'100%',
    height:'auto',
    boxSizing:'border-box',
    padding:rhythm(1),
    paddingRight: rhythm(.01),
    marginTop: '-60px'
  })
  return (
    <React.Fragment>
    <div
      ref={seriesChart}
      {...chartStyles}
    >
      <ResetButton chart={newChart} />
      <label>Activity By Date</label>
      <Options chart={[chart, newChart]} chartType={props.type}/>
    </div>
    <div
      ref={rangeChart}
      {...chartStylesRange}
    >

    </div>
    </React.Fragment>
  );
};
